var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SkeletonTheme',{attrs:{"color":"#e3e3e3","highlight":"#c3c3c3"}},[_c('Skeleton',{attrs:{"height":_vm.height,"width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }